<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.46 11.72L10.48 8.54C9.43001 7.71 7.97001 7.71 6.91001 8.54L2.97001 11.7C2.37001 12.15 2.02001 12.85 2.01001 13.61V18.89C2.01001 19.7 2.33001 20.46 2.91001 21.04C3.48001 21.61 4.24001 21.92 5.04001 21.92H12.36C13.17 21.92 13.92 21.61 14.5 21.04C15.08 20.47 15.4 19.71 15.4 18.9V13.6C15.39 12.85 15.04 12.16 14.46 11.73V11.72ZM13.49 18.89C13.49 19.19 13.37 19.48 13.15 19.69C12.94 19.9 12.65 20.02 12.34 20.02H9.64001V17.18C9.64001 16.66 9.21001 16.23 8.69001 16.23C8.17001 16.23 7.74001 16.66 7.74001 17.18V20.02H5.04001C4.77001 20 4.45001 19.9 4.23001 19.69C4.01001 19.48 3.89001 19.19 3.89001 18.89V13.63C3.89001 13.47 3.97001 13.32 4.12001 13.21L8.08001 10.03C8.26001 9.89 8.47001 9.82 8.69001 9.82C8.91001 9.82 9.11001 9.89 9.29001 10.03L13.29 13.22C13.42 13.32 13.49 13.47 13.5 13.61V18.89H13.49Z"
      fill="currentColor"
    />
    <path
      d="M18.81 3H13.59C11.89 3 10.52 4.38 10.52 6.07V6.95C10.52 7.47 10.95 7.9 11.47 7.9C11.99 7.9 12.42 7.47 12.42 6.95V6.07C12.42 5.42 12.95 4.9 13.59 4.9H18.81C19.46 4.9 20 5.43 20 6.09V18.73C20 19.38 19.47 19.92 18.81 19.92H17.51C16.99 19.92 16.56 20.35 16.56 20.87C16.56 21.39 16.99 21.82 17.51 21.82H18.81C20.51 21.82 21.9 20.44 21.9 18.73V6.09C21.9 4.39 20.52 3 18.81 3Z"
      fill="currentColor"
    />
    <path
      d="M17.72 17.68C18.24 17.68 18.67 17.25 18.67 16.73C18.67 16.2 18.24 15.77 17.72 15.77C17.2 15.77 16.77 16.2 16.77 16.73C16.77 17.26 17.2 17.68 17.72 17.68Z"
      fill="currentColor"
    />
    <path
      d="M16.77 12.5C16.77 13.02 17.2 13.45 17.72 13.45C18.24 13.45 18.67 13.02 18.67 12.49C18.67 11.96 18.24 11.54 17.72 11.54C17.2 11.54 16.77 11.97 16.77 12.49V12.5Z"
      fill="currentColor"
    />
    <path
      d="M14.66 7.33C14.14 7.33 13.71 7.76 13.71 8.29C13.71 8.82 14.14 9.24 14.66 9.24C15.18 9.24 15.61 8.81 15.61 8.29C15.61 7.76 15.18 7.33 14.66 7.33Z"
      fill="currentColor"
    />
    <path
      d="M17.72 9.23C18.24 9.23 18.67 8.8 18.67 8.28C18.67 7.75 18.24 7.32 17.72 7.32C17.2 7.32 16.77 7.75 16.77 8.28C16.77 8.81 17.2 9.23 17.72 9.23Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
